import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { AlertProps } from 'shared/mui/Alert/Alert';
import { CloseIconButton } from 'shared/mui/IconButtons';
import { getReportPeriod } from 'utils/getReportPeriod';

import { AlertStyled } from './SuccessReportAlert.styled';

type Props = {
  onClose: VoidFunction;
  date?: {
    gte?: number | null;
    lte?: number | null;
  };
  timezone?: string;
  actionButton?: JSX.Element;
} & AlertProps;

export const SuccessReportAlert: React.FC<Props> = ({ onClose, date, timezone, actionButton }) => {
  const translate = useTypedTranslate();
  return (
    <AlertStyled
      action={[
        actionButton && actionButton,
        <CloseIconButton color="inherit" key="close-button" onClose={onClose} />,
      ]}
      severity="success"
    >
      {translate('app.filter.reportGeneratedForPeriod')}{' '}
      {getReportPeriod({ dateGte: date?.gte, dateLte: date?.lte, timezone })}
    </AlertStyled>
  );
};
